import axios from '@/services/axios';

export async function loadLojaProducts() {
  const { data } = await axios.get('/cadastros/produtos', { params: { ativo: true, limit: 1000 } });
  const rows = data?.data ?? data;
  if (!Array.isArray(rows)) throw new Error('Resposta inválida do catálogo de produtos.');
  return rows.map(p => ({
    id: p.id, texto: `${p.codigo} – ${p.nome}`,
    preco: parseFloat(p.preco_venda), estoque: p.estoque
  }));
}

export function lojaSelectionError(error, catalog) {
  if (error.response?.status === 403) return `Você não possui permissão para consultar ${catalog} nesta operação.`;
  if (error.message?.startsWith('Resposta inválida')) return error.message;
  if (error.response) return `Erro do servidor ao carregar ${catalog}. Reabra o formulário para tentar novamente.`;
  return `Erro de comunicação ao carregar ${catalog}. Reabra o formulário para tentar novamente.`;
}
